import script from "./MainCommnetInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MainCommnetInput.vue?vue&type=script&setup=true&lang=js"

import "./MainCommnetInput.vue?vue&type=style&index=0&id=16847010&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16847010"]])

export default __exports__